import { RouteConfig } from 'vue-router'

const List = () => import('../../views/assignment-record/List.vue')

export const listRoute: RouteConfig = {
  path: '/assignment-record/list',
  name: 'assignment_record_list',
  component: List,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '成长记录册',
  },
}

export default [listRoute]
